import { gql } from '@apollo/client';

export const VERIFY_LINE_ITEM_IN_FILTERS = gql`
  query VERIFY_LINE_ITEM_IN_FILTERS($filterOptions: LineItemFilterOptionsV5) {
    lineItems: lineItemsV5(filterOptions: $filterOptions, paginationOptions: { limit: 1, offset: 0 }) {
      total
    }
  }
`;
